import React, { useContext } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import AdjustableScreen from "~/layouts/AdjustableScreen/index.web";

import SettingsScreen from "~/screens/SettingsScreen/index.web";
import InboxScreen from "~/screens/InboxScreen/index.web";
import OnboardingScreen from "~/screens/OnboardingScreen/index.web";
import CustomersScreen from "~/screens/CustomersScreen/index.web";
import CallsScreen from "~/screens/CallsScreen/index.web";
import VoicemailsScreen from "~/screens/VoicemailsScreen/index.web";

import { ConversationProvider } from "~/contexts/ConversationContext";
import UserContext from "~/contexts/UserContext";
import HashRoute from "~/routers/HashRoute";
import CustomerCreateModal from "~/modals/CustomerCreateModal/index.web";
import IncomingCallModal from "~/modals/IncomingCallModal/index.web";
import { NumbersProvider } from "~/contexts/NumbersContext";
import { CustomersProvider } from "~/contexts/CustomersContext";
import { ThreadsProvider } from "~/contexts/ThreadsContext";
import { PusherProvider } from "~/contexts/PusherContext";
import { BadgeProvider } from "~/contexts/BadgeContext";
import { TwilioProvider } from "~/contexts/TwilioContext/index.web";
import { TeamProvider } from "../../contexts/TeamContext";

export default function HomeScreen() {
  const { loggedIn } = useContext(UserContext);

  if (!loggedIn) {
    return <Redirect to="/login" />;
  }

  return (
    <NumbersProvider>
      <TwilioProvider>
        <PusherProvider>
          <BadgeProvider>
            <ConversationProvider>
              <ThreadsProvider>
                <CustomersProvider>
                  <TeamProvider>
                    <AdjustableScreen>
                      <Switch>
                        <Route path="/onboard" component={OnboardingScreen} />
                        <Route path="/calls" component={CallsScreen} />
                        <Route path="/customers" component={CustomersScreen} />
                        <Route path="/settings" component={SettingsScreen} />
                        <Route path="/messages" component={InboxScreen} />
                        <Route path="/voicemails" component={VoicemailsScreen} />
                        <Route>
                          <Redirect to={`/calls`} />
                        </Route>
                      </Switch>
                      <Switch>
                        <HashRoute
                          hash="#new-customer"
                          path="/"
                          component={CustomerCreateModal}
                        />
                      </Switch>
                      <IncomingCallModal />
                    </AdjustableScreen>
                  </TeamProvider>
                </CustomersProvider>
              </ThreadsProvider>
            </ConversationProvider>
          </BadgeProvider>
        </PusherProvider>
      </TwilioProvider>
    </NumbersProvider>
  );
}
